import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import { HiExclamationCircle } from "react-icons/hi";

interface RemoveAssignmentDialogProps {
  open: boolean;
  userName: string;
  orgName: string;
  roleName: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

const RemoveAssignmentDialog: React.FC<RemoveAssignmentDialogProps> = ({
  open,
  userName,
  orgName,
  roleName,
  onConfirm,
  onCancel,
  loading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      aria-labelledby="remove-assignment-dialog-title"
      aria-modal="true"
    >
      <DialogTitle
        id="remove-assignment-dialog-title"
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        <HiExclamationCircle size={22} color="#f59e0b" />
        Remover Asignación
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 1 }}>
          ¿Está seguro de que desea remover la asignación de:
        </Typography>
        <Box sx={{ pl: 2, mb: 1 }}>
          <Typography variant="body2">
            <strong>Usuario:</strong> {userName}
          </Typography>
          <Typography variant="body2">
            <strong>Organización:</strong> {orgName}
          </Typography>
          <Typography variant="body2">
            <strong>Rol:</strong> {roleName}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : undefined}
        >
          {loading ? "Removiendo..." : "Remover"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveAssignmentDialog;
